import { render, staticRenderFns } from "./pick_sample.vue?vue&type=template&id=0890e4ad&scoped=true&"
import script from "./pick_sample.vue?vue&type=script&lang=js&"
export * from "./pick_sample.vue?vue&type=script&lang=js&"
import style0 from "./pick_sample.vue?vue&type=style&index=0&id=0890e4ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0890e4ad",
  null
  
)

export default component.exports